import { SxProps } from '@mui/material';

const ACCORDION_HEIGHT = '3rem';

type Overrides = {
  stickyOffset?: string;
};

export const CATEGORY_ACCORDION_SX = ({ stickyOffset = '0' }: Overrides = {}): SxProps => ({
  '& .MuiAccordion-root.Mui-expanded::before': { opacity: 1 },
  '& .MuiAccordionSummary-root': {
    minHeight: ACCORDION_HEIGHT,
    height: ACCORDION_HEIGHT,
    backgroundColor: 'grey.200',
    color: 'grey.700',
    textTransform: 'uppercase',
    fontWeight: 500,
    position: 'sticky',
    top: stickyOffset,
    zIndex: 2,
    justifyContent: 'space-between',
    '&.Mui-focusVisible, &:hover': { backgroundColor: 'grey.300', color: 'grey.800' },
    '& .MuiAccordionSummary-content': {
      flexGrow: 0,
      position: 'sticky',
      left: '1rem',
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      position: 'sticky',
      right: '1rem',
    },
  },
  '& .MuiAccordionDetails-root': { p: 0 },
});
